import { useHover } from '@uidotdev/usehooks'
import { cn } from '../misc'

interface StyleOptions {
	ring?: boolean
	cursorPointer?: boolean
	// TODO: This isn't working anymore but nothing has changed from when it was?
	overrideScaleFactor?: string
}

export default function useHighlightOnHover<T extends Element>(
	styleOptions: StyleOptions = {},
): [React.RefCallback<T>, boolean, string] {
	const [ref, isHovered] = useHover()
	const highlightedClassName = cn(
		'shadow-md shadow-accent',
		styleOptions.overrideScaleFactor
			? `scale-[${styleOptions.overrideScaleFactor}]`
			: 'scale-[1.01]',
		styleOptions.ring ? 'ring-2' : '',
		styleOptions.cursorPointer ? 'cursor-pointer' : '',
	)
	return [ref, isHovered, highlightedClassName]
}
